<template>
    <div>
      <v-dialog v-model="dialog" max-width="600" persistent>
        <v-card class="text-center">
          <v-card-text class="pa-6">

            <v-img :src="url"></v-img>
            
            <v-btn text class="rounded-lg mr-2 text-none mt-4" large  @click="$preview_image_dialog = false">
              <v-icon left>mdi-close</v-icon>   Fermer
            </v-btn>
            
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        dialog: false,
        file: null
      }
    },
    computed: {
      url(){
        if(this.file == null){
          return "";
        }
        return URL.createObjectURL(this.file)
      }
    },
    watch: {
      '$preview_image_dialog': function (el) {
        this.dialog = !!el;
      },
      '$preview_image_file': function (file) {
        this.file = file;
      }
    },
  }
  </script>
  
  <style scoped>
  .lb-grid{position:relative;display:block}.lb-item{position:absolute;background-position:50%;background-repeat:no-repeat;background-size:cover;border-top:2px solid #fff;border-right:2px solid #fff;cursor:pointer}.lb-grid-1 .lb-item{width:100%;height:100%}.lb-grid-2 .lb-item,.lb-grid-3 .lb-item,.lb-grid-4 .lb-item,.lb-grid-5 .lb-item{width:50%}.lb-grid-2 .lb-item,.lb-grid-3 .lb-item:first-child,.lb-grid-4 .lb-item:first-child{height:100%}.lb-grid-3 .lb-item:nth-child(2),.lb-grid-3 .lb-item:nth-child(3),.lb-grid-5 .lb-item:first-child,.lb-grid-5 .lb-item:nth-child(2){height:50%}.lb-grid-2 .lb-item:nth-child(2),.lb-grid-3 .lb-item:nth-child(2),.lb-grid-3 .lb-item:nth-child(3),.lb-grid-4 .lb-item:nth-child(2),.lb-grid-4 .lb-item:nth-child(3),.lb-grid-4 .lb-item:nth-child(4),.lb-grid-5 .lb-item:nth-child(3),.lb-grid-5 .lb-item:nth-child(4),.lb-grid-5 .lb-item:nth-child(5),.lb-item:last-child{left:auto;right:0;border-right:0}.lb-grid-3 .lb-item:nth-child(3),.lb-grid-4 .lb-item:nth-child(4),.lb-grid-5 .lb-item:nth-child(2),.lb-grid-5 .lb-item:nth-child(5){bottom:0;top:auto}.lb-grid-4 .lb-item:nth-child(3),.lb-grid-5 .lb-item:nth-child(4){top:33.333333333333336%}.lb-grid-4 .lb-item:nth-child(2),.lb-grid-4 .lb-item:nth-child(3),.lb-grid-4 .lb-item:nth-child(4),.lb-grid-5 .lb-item:nth-child(3),.lb-grid-5 .lb-item:nth-child(4),.lb-grid-5 .lb-item:nth-child(5){height:33.333333333333336%}.lb-more{position:absolute;top:0;left:0;right:0;bottom:0;text-align:center;color:#fff;font-size:3rem;background-color:rgba(0,0,0,.4)}.lb-more:before{display:inline-block;content:"";vertical-align:middle;height:100%}.lb-modal{transition:opacity .2s ease;position:fixed;z-index:99999;top:0;left:0;bottom:0;right:0;width:100%;min-height:100%;height:100vh;background-color:rgba(0,0,0,.8);display:block;-webkit-user-select:none;-moz-user-select:-moz-none;-o-user-select:none;-ms-user-select:none;user-select:none}.lb-modal-close{position:absolute;right:20px;top:20px;color:#fff}.lb-modal-next,.lb-modal-prev{position:absolute;top:50%;left:20px;margin-top:-25px;z-index:999;cursor:pointer;color:#fff;background-color:transparent;border:none}.lb-modal-next{left:auto;right:20px}.lb-modal-img{position:absolute;top:10px;left:70px;right:70px;bottom:10px;text-align:center}.lb-modal-img:before{display:inline-block;content:"";vertical-align:middle;height:100%}.lb-modal-img img{max-width:100%;max-height:100%;vertical-align:middle;-o-object-fit:contain;object-fit:contain}.lb-modal-img .spinner{width:150px;position:absolute;margin-left:-75px;top:50%;left:50%;z-index:1}
  </style>